import { IState } from './types';

export type { IState } from './types';

import { InferValueTypes } from '~/src/store';

import * as actionCreators from './actions';

export const actionTypes = {
    INITIALIZED: '@PASSPORT_UPDATE/INITIALIZED',
    DOWN_NEW_ENTER_FLAG: '@PASSPORT_UPDATE/DOWN_NEW_ENTER_FLAG',
    START_GETTING_CODE: '@PASSPORT_UPDATE/START_GETTING_CODE',
    SET_CODE: '@PASSPORT_UPDATE/SET_CODE',
    UPDATING_DATA: '@PASSPORT_UPDATE/UPDATING_DATA',
    UPDATE_SUCCESS: '@PASSPORT_UPDATE/UPDATE_SUCCESS',
    UPDATE_ERROR: '@PASSPORT_UPDATE/UPDATE_ERROR',
    UPDATE_INCORRECT: '@PASSPORT_UPDATE/UPDATE_INCORRECT',
    RESET: '@PASSPORT_UPDATE/RESET',
} as const;

export type TAction = ReturnType<InferValueTypes<typeof actionCreators>>;

/**
 * По дефолту считаем что данные актуальны
 * type TUpdateStatus = 'notInit' | 'checking' | 'fetchingCode' | 'updating' | 'result'
 */
export const initState: IState = {
    status: 'notInit',
    isLoading: false,
    isNewEnter: false,
    isDataActual: true,
    gosuslugiCode: '',
    isUpdateSuccess: false,
    isDataInCorrect: false,
};

export const reducer = (state: IState = initState, action: TAction): IState => {
    switch (action.type) {
        case actionTypes.INITIALIZED: {
            return {
                ...state,
                isLoading: false,
                status: 'checking',
                isNewEnter: action.payload.isNewEnter,
                isDataActual: action.payload.isActualData,
            };
        }
        case actionTypes.DOWN_NEW_ENTER_FLAG: {
            return {
                ...state,
                isNewEnter: false,
            };
        }
        case actionTypes.START_GETTING_CODE: {
            return {
                ...state,
                isLoading: true,
                status: 'fetchingCode',
            };
        }
        case actionTypes.UPDATING_DATA: {
            return {
                ...state,
                isLoading: true,
                status: 'updating',
                gosuslugiCode: '',
            };
        }
        case actionTypes.UPDATE_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                status: 'result',
                isUpdateSuccess: true,
            };
        }
        case actionTypes.UPDATE_ERROR: {
            return {
                ...state,
                isLoading: false,
                status: 'result',
                isUpdateSuccess: false,
            };
        }
        case actionTypes.UPDATE_INCORRECT: {
            return {
                ...state,
                isLoading: false,
                status: 'result',
                isUpdateSuccess: false,
                isDataInCorrect: true,
            };
        }
        case actionTypes.RESET: {
            return initState;
        }
        default: {
            const neverAction: never = action;
            return state || neverAction;
        }
    }
};
